import * as yup from "yup";

import { useState, useEffect, useCallback } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import ReactSelect from "../../../components/common/ReactSelect";
import Toaster from "./../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";
import taxService from "./../../../services/taxService";

const schema = yup.object();

const CorsFilter = ({ tableOptions, onFilter }) => {
  const [rdos, setRdos] = useState([]);

  const statuses = complianceService.getCORStatuses();
  const show_options = complianceService.getCORShowOptions();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const fetchRdos = useCallback(async (mounted) => {
    try {
      const result = await taxService.getRevenueDistrictOfficesAsync();

      const options = result.map((item) => {
        const option = {};
        option["label"] = item;
        option["value"] = item;

        return option;
      });

      if (mounted) setRdos(options);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  }, []);

  const onSubmit = (data) => {
    const status =
      data.status && data.status.label !== undefined ? data.status.label : "";
    const rdo = data.rdo && data.rdo.value !== undefined ? data.rdo.value : "";
    const cor = data.cor && data.cor.value !== undefined ? data.cor.value : "";
    const show = data.cor && data.cor.label !== undefined ? data.cor.label : "";
    const start_date = "";
    const end_date = "";

    onFilter(status, rdo, cor, show, start_date, end_date);
  };

  const handleReset = () => {
    const status = "";
    const rdo = "";
    const cor = "";
    const show = "";
    const start_date = "";
    const end_date = "";

    onFilter(status, rdo, cor, show, start_date, end_date);
  };

  useEffect(() => {
    let mounted = true;

    fetchRdos(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchRdos]);

  useEffect(() => {
    if (tableOptions) {
      const { rdo, cor, status } = tableOptions;

      const statuses = complianceService.getCORStatuses();
      const show_options = complianceService.getCORShowOptions();

      const selected_rdo = rdo ? { label: rdo, value: rdo } : null;
      const selected_status = statuses.filter((i) => i.label === status);
      const selected_display = show_options.filter((i) => i.value === cor);

      setValue("rdo", selected_rdo);
      setValue("status", selected_status[0]);
      setValue("cor", selected_display[0]);
    }
  }, [tableOptions, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="rdo-dropdown"
            name="rdo"
            title="RDO"
            options={rdos}
            control={control}
            register={register("rdo")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="cor-dropdown"
            name="cor"
            title="Show"
            options={show_options}
            control={control}
            register={register("cor")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={() => handleReset()}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default CorsFilter;
